import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage, Input,
  LifeSaverForm,
  ScreenHeader
} from '../../components';
import { useCreateOrUpdate, useFormData } from '../../hooks';

import { NewFAContext } from '.';

const formConfig = {
  fields: [
    { 
      id: 'ceremony-details', 
      fieldName: 'ceremony_details',
      type: 'text' as const,
      required: true 
    }
  ]
};


export function NewFACeremonyDetails() {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleCreateOrUpdate } = useCreateOrUpdate('funeral_arrangements');
  const { handleData, errors } = useFormData(formConfig);
    
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const formData = handleData();
    
    // Validate required fields
    if (!formData.ceremony_details) {
      return;
    }

    const payload = {
      ...formData,
      user_id: funeralArrangement?.user_id || null,
      person_id: funeralArrangement?.person_id || null
    };

    try {
      await handleCreateOrUpdate(funeralArrangement?.id || '', payload);
      await update();
      navigate('../obituary-preferences');
    } catch (err) {
      console.error('Error saving ceremony details:', err);
    }
  }, [ navigate, funeralArrangement, handleCreateOrUpdate, update, handleData ]);

  return (
    <div className="new-fa-disposition screen">
      <ScreenHeader 
        title="Ceremony Preferences"
        description="Specify your ceremony preferences and arrangements."
        steps={6}
        step={1}
        handleBack={handleBack}
      />
      
      <LifeSaverForm
        header="Ceremony Details"
        icon="celebration"
      >
        <Input
          id="ceremony-details"
          name="ceremony_details"
          label="Ceremony Details"
          placeholder="Enter details about the ceremony, such as location, date, and any specific requests."
          type="textarea"
          rows={4}
          required={true}
        />
      </LifeSaverForm>

      <ErrorMessage message={errors[0]} />

      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}